import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import heroBg from "@/assets/hero-bg.jpg";
import { trackEvent } from "@/lib/analytics";
const Hero = () => {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Optimized background image */}
      <img 
        src={heroBg}
        alt="AI-labbet hero background"
        className="absolute inset-0 w-full h-full object-cover"
        loading="eager"
        width="1920"
        height="1080"
      />
      
      {/* Overlay for better text readability */}
      <div className="absolute inset-0 bg-background/40 backdrop-blur-[2px]" />
      
      {/* Content */}
      <div className="relative z-10 container mx-auto px-6 text-center">
        <h2 className="text-5xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight">
          We create business value with{" "}
          <span className="text-primary">Responsible AI</span>
        </h2>
        
        <p className="text-xl md:text-2xl text-muted-foreground mb-12 max-w-3xl mx-auto">
          Empowering organizations through strategy, governance, and transformative AI journeys
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Button variant="primary" size="xl" asChild>
            <Link
              to="/contact"
              onClick={() => trackEvent("cta_click", { cta_id: "hero_strategy_session", location: "hero" })}
            >
              Book a Strategy Session
            </Link>
          </Button>
        </div>
      </div>

      {/* Decorative gradient overlay */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-background to-transparent" />
    </section>;
};
export default Hero;